import type { RuleObject } from "antd/lib/form";
import type { StoreValue } from "rc-field-form/lib/interface";

const validateIranianMobile = (
    _: RuleObject,
    value: StoreValue
): Promise<void> => {
    const regex = /^(\+98|0)?9\d{9}$/;
    if (!value || regex.test(value)) {
        return Promise.resolve();
    }
    return Promise.reject("شماره موبایل معتبر نمی باشد.");
};

const validateIranianNationalCode = (
    _: RuleObject,
    value: StoreValue
): Promise<void> => {
    if (!value ) {
        return Promise.resolve();
    }
    if (!/^\d{10}$/.test(value)) return Promise.reject("کدملی باید 10 رقم باشد.");

    const check = +value[9];
    const sum = [...value].slice(0, 9).reduce((acc, digit, index) => {
        return acc + (+digit * (10 - index));
    }, 0);
    const remainder = sum % 11;

    const isValid =
        (remainder < 2 && check === remainder) ||
        (remainder >= 2 && check === 11 - remainder);

    return isValid
        ? Promise.resolve()
        : Promise.reject("کدملی معتبر نمی باشد.");
};
const validateIranianCompanyNationalCode = (
    _: RuleObject,
    value: StoreValue
): Promise<void> => {
    if (!value ) {
        return Promise.resolve();
    }
    if (!/^\d{11}$/.test(value)) return Promise.reject("شناسه ملی باید 11 رقم باشد.");
    return Promise.resolve()


};
const validateTrackingId = (
    _: RuleObject,
    value: StoreValue
): Promise<void> => {
    if (!value) {
        return Promise.resolve();
    }
    if (!/^\d+$/.test(value)) {
        return Promise.reject("شناسه درخواست باید فقط شامل ارقام باشد.");
    }
    return Promise.resolve();
};
export {validateIranianNationalCode,validateTrackingId,validateIranianMobile,validateIranianCompanyNationalCode}